export const WIDTH_TOOLTIP = 334
export const HEIGHT_TOOLTIP = 213

export const WIDTH_TOOLTIP_SMALL = 223
export const HEIGHT_TOOLTIP_SMALL = 155


